import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import LoadingPage from '../../../v2SPRINTA/molecules/LoadingPage'
import { experienceFind, publishExperience } from '../CreateExperience/_utils'

import Calendar from '../CreateExperience/Steps/Calendar'
import Where from '../CreateExperience/Steps/Where'
import CalendarGym from '../CreateGym/Steps/Calendar'
import WhereGym from '../CreateGym/Steps/Where'
import NavigationBar from '../CreateExperience/NavigationBar'
import BoxAccordion from '../../../v2SPRINTA/atoms/BoxAccordion'
import Button from '../../../v2SPRINTA/atoms/Button'
import ScrollTo, { calcDistanceElement } from '../../../SPRINTA/atoms/ScrollTo'

import Divider from '../CreateExperience/Divider'
import CoverImage from '../../../SPRINTA/atoms/CoverImage'

import { Container, Row, Col, FluidContainer } from '../../../v2SPRINTA/atoms/Grid'
import Display from '../../../v2SPRINTA/atoms/Display'
import Loading from '../../../SPRINTA/atoms/Loading'
class ExperienceApproved extends Component {
    state = {
        loading: true,
        step: 1,
        steps: 2,
        done: false,
        publishing: false
    }

    constructor(props) {
        super(props)
        this.step = {}


        experienceFind(props.match.params.token)
        .then(resp => {
            if(resp.errors && resp.errors.length) {
                this.setState({
                    loading: false
                })
                return
            }

            this.setState({
                token: props.match.params.token,
                loading: false,
                data: resp
            })
        })
    }
    
    componentDidMount() {
        window.scrollTo(0, 0)
    }


    handleNextStep() {
        const { step, steps } = this.state

        

        let newStep = step + 1

        let err = []
        for (let i = 1; i <= step; i++) {
            if(!this.step[i] || !this.step[i].validate) continue;

            let e = this.step[i].validate()

            if(e)
            err = [...err, ...e]
        }

        if(err.length > 0) {
            this.setState({
                errors: err
            })
            return 
        }

        if(step >= steps) {
            this.setState({
                // loadingDone: true,
                done: true
            }, () => {
                let topDistance = calcDistanceElement(this.refs.finisher)
                ScrollTo(topDistance-68)
            })

            return
        }

        window.setTimeout(() => {
            let topDistance = calcDistanceElement(document.getElementById('step'+newStep))
            ScrollTo(topDistance-68)
        }, 300)

        
        this.setState({
            step: newStep,
            errors: null
        })
        
    }

    setData(data, f) {
        this.setState({
            data: {
                ...this.state.data,
                ...data
            }
        }, () => {
            if(f) f()
        })
    }

    asyncMethod(async) {
        this.setState({
            asyncMethods: this.state.asyncMethods + 1
        })
        
        Promise.resolve(async)
        .then(() => {
            this.setState({
                asyncMethods: this.state.asyncMethods - 1
            })
        })
    }

    publishExperience() {
        this.setState({
            publishing: true
        })
        
        if(this.state.asyncMethods > 0) {

            this.timeoutPublish = window.setTimeout(() => {
                this.publishExperience()
            }, 1000)

            return
        }

        if(this.timeoutPublish)
        window.clearTimeout(this.timeoutPublish)

        if(this.state.data.experience.kind === 'XP') {
            publishExperience(this.state.token)
            .then(resp => {
                this.props.history.push(`/create/experience/finished/${this.state.token}`)
            })
        }

        if(this.state.data.experience.kind === 'GYM') {
            publishExperience(this.state.token)
            .then(resp => {
                this.props.history.push(`/create/gym/finished/${this.state.token}`)
            })
        }

    }


    render() {
        let steps = {
            current: this.state.step,
            size: this.state.steps
        }

        if(this.state.loading) 
        return <LoadingPage />

        if(!this.state.data || this.state.data.experience.status !== 3)
        return <Redirect to='/create/experience' />
        
        if(this.state.data.experience.kind === 'XP') {
            return (
                <div>
                    <FluidContainer>
                        <Row>  
                            <CoverImage
                                    image={this.state.data.cover ? this.state.data.cover.url : null}
                                    shadow='300'
                                    style={{ backgroundColor: '#333', color: '#fff' }}>
                                    <Container>
                                        <Row alignItems='center' justifyContent="center"  style={{ paddingTop: '100px' }}>
                                            <Col size='12 12 11' text='center' style={{ marginBottom: '80px' }}>
                                                <Display heading size={1}>Finalizando sua <b>experiência</b></Display>
                                                <br />

                                                <Display size={2}>
                                                    Quase lá! Sua experiência foi aprovada e agora são alguns poucos detalhes que separam ela da publicação
                                                </Display>
                                                <br />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col size='12' text='center' style={{ marginBottom: '60px' }}>
                                                <b>{this.state.data.experience.title}</b> <br />
                                                {this.state.data.experience.city} ({this.state.data.experience.state})
                                            </Col>
                                        </Row>
                                    </Container>
                            </CoverImage>
                        </Row>
                    </FluidContainer>

                    <Calendar
                        steps={{
                            ...steps,
                            self: 1
                        }}
                        ref={ref => this.step[1] = ref}
                        token={this.state.token}
                        duration={this.state.data.experience.duration} />
                    

                    <div id='step2'>
                        <BoxAccordion show={this.state.step >= 2}>
                            <Divider />
                            <Where
                                steps={{
                                    ...steps,
                                    self: 2
                                }}
                                ref={ref => this.step[2] = ref}
                                token={this.state.token}
                                async={item => this.asyncMethod(item)}
                                data={this.state.data}
                                setData={(data, f) => this.setData(data, f)} /> 
                        </BoxAccordion>
                    </div>
                    {!this.state.done ? (

                        <NavigationBar
                        errors={this.state.errors}
                        loadingDone={this.state.loadingDone}
                        step={this.state.step}
                        steps={this.state.steps}
                        handleNextStep={() => this.handleNextStep()}
                        finish={`Publicar experiência`}
                        />
                    ) : (
                        <div ref="finisher">
                            <Divider />
                            <Container style={{ paddingTop: '60px', paddingBottom: '60px' }}>
                                <Row>
                                    <Col size='12' text='center'>
                                        <Display size={2}>Tudo pronto? <br /> Agora é só <b>publicar sua experiência</b>!</Display>
                                        <br />
                                        Publique sua experiência para mais de 320 mil atletas presente no SPRINTA.
                                        <br />
                                        <div style={{ marginTop: '30px' }}>
                                            {this.state.publishing ? (
                                                <Loading />
                                            ) : (
                                                <Button onClick={() => this.publishExperience()} inline primary>Publicar experiência</Button>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    )}
                        
                </div>
            )
        }

        if(this.state.data.experience.kind === 'GYM') {
            return (
                <div>
                    <FluidContainer>
                        <Row>  
                            <CoverImage
                                    image={this.state.data.cover ? this.state.data.cover.url : null}
                                    shadow='300'
                                    style={{ backgroundColor: '#333', color: '#fff' }}>
                                    <Container>
                                        <Row alignItems='center' justifyContent="center"  style={{ paddingTop: '100px' }}>
                                            <Col size='12 12 11' text='center' style={{ marginBottom: '80px' }}>
                                                <Display heading size={1}>Finalizando o cadastro da sua <b>academia</b></Display>
                                                <br />

                                                <Display size={2}>
                                                    Quase lá! Sua academia foi aprovada e agora são alguns poucos detalhes que separam ela da publicação
                                                </Display>
                                                <br />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col size='12' text='center' style={{ marginBottom: '60px' }}>
                                                <b>{this.state.data.experience.title}</b> <br />
                                                {this.state.data.experience.city} ({this.state.data.experience.state})
                                            </Col>
                                        </Row>
                                    </Container>
                            </CoverImage>
                        </Row>
                    </FluidContainer>

                    <CalendarGym
                        steps={{
                            ...steps,
                            self: 1
                        }}
                        ref={ref => this.step[1] = ref}
                        token={this.state.token}
                        duration={this.state.data.experience.duration} />
                    

                    <div id='step2'>
                        <BoxAccordion show={this.state.step >= 2}>
                            <Divider />
                            <WhereGym
                                steps={{
                                    ...steps,
                                    self: 2
                                }}
                                ref={ref => this.step[2] = ref}
                                token={this.state.token}
                                async={item => this.asyncMethod(item)}
                                data={this.state.data}
                                setData={(data, f) => this.setData(data, f)} /> 
                        </BoxAccordion>
                    </div>
                    {!this.state.done ? (

                        <NavigationBar
                        errors={this.state.errors}
                        loadingDone={this.state.loadingDone}
                        step={this.state.step}
                        steps={this.state.steps}
                        handleNextStep={() => this.handleNextStep()}
                        finish={`Publicar academia`}
                        />
                    ) : (
                        <div ref="finisher">
                            <Divider />
                            <Container style={{ paddingTop: '60px', paddingBottom: '60px' }}>
                                <Row>
                                    <Col size='12' text='center'>
                                        <Display size={2}>Tudo pronto? <br /> Agora é só <b>finalizar o cadastro</b>!</Display>
                                        <br />
                                        Publique sua academia para mais de 320 mil atletas presente no SPRINTA.
                                        <br />
                                        <div style={{ marginTop: '30px' }}>
                                            {this.state.publishing ? (
                                                <Loading />
                                            ) : (
                                                <Button onClick={() => this.publishExperience()} inline primary>Publicar academia</Button>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    )}
                        
                </div>
            )
        }

        return null
    }

}

export default ExperienceApproved


// WEBPACK FOOTER //
// ./src/App/pages/ExperienceContinue/index.js